// Vendor
import * as React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

// Internal
import { Image } from '@src/components/Image/Image';
import { DEFAULT_SAL_PROPS, SAL_DELAY } from '@src/config/sal';

// Styles
import styles from './styles.module.css';

const getInvestmentPieces = graphql`
  query getInvestmentPieces {
    allInvestmentPiecesJson {
      nodes {
        image {
          alt
          fileName
          maxWidth
        }
        links {
          link
          title
        }
        title
      }
    }
  }
`;

const InvestmentPieces: React.FC = () => {
  // Hooks
  const data =
    useStaticQuery<GatsbyTypes.getInvestmentPiecesQuery>(getInvestmentPieces);
  const pieces = data.allInvestmentPiecesJson.nodes;

  // Markup
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const renderLink = (item: any) => {
    const { link, title } = item;
    return (
      <li key={title}>
        <a href={link} target="_blank" rel="noopener noreferrer">
          {title}
        </a>
      </li>
    );
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const renderPiece = (item: any, index: number) => {
    const { image, links, title } = item;
    const { alt, fileName, maxWidth } = image;
    const delay = index * SAL_DELAY;

    return (
      <div
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={delay}
        className={styles.piece}
        key={title}
      >
        <Image alt={alt} fileName={fileName} maxWidth={maxWidth} />
        <h2>
          <span>{index + 1}.</span> {title}
        </h2>
        <ul>{links.map(renderLink)}</ul>
      </div>
    );
  };

  return (
    <div className="tup-slide">
      <h1 {...DEFAULT_SAL_PROPS}>Top Resellable Categories and Brands</h1>
      <p className="tup-body">
        Pieces with the highest resale value that make it worth the investment.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {pieces.map(renderPiece)}
        <div {...DEFAULT_SAL_PROPS} data-sal-delay={250}>
          <Image
            alt="Woman with handbag"
            fileName="7c-onfigure-bag.jpg"
            maxWidth={240}
          />
        </div>
      </div>
      <p
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={300}
        className="tup-source text-center mt-8 max-w-3xl m-auto"
      >
        Resale Value Ranking: thredUP evaluated 35,000+ unique brands on its
        platform and created an aggregate score to determine a brand&apos;s
        ranking based on demand, virality, and value to the seller.
      </p>
    </div>
  );
};

export { InvestmentPieces };
